export const WestFordFlat_Device_Points_Config = {
  M1_52_DATA_POINTS: [
    {
      label: '52M1 Status',
      pointName: 'msg_52_m1_52a',
      ignoreInLableValueRender: true,
    },
    {
      label: 'Average Volts',
      pointName: 'll_average_volts',
    },
    {
      label: 'A Phase Amps',
      pointName: 'a_phase_amps',
    },
    {
      label: 'MW Comp',
      pointName: 'mw_comp',
    },
    {
      label: 'MVar Comp',
      pointName: 'mvar_comp',
    },
  ],
  F1_52_DATA_POINTS: [
    {
      label: '52F1 Status',
      pointName: 'msg_52_f1_52a',
    },
  ],
  F2_52_DATA_POINTS: [
    {
      label: '52F2 Status',
      pointName: 'msg_52_f2_52a',
    },
  ],
  F3_52_DATA_POINTS: [
    {
      label: '52F3 Status',
      pointName: 'msg_52_f3_52a',
    },
  ],
  F4_52_DATA_POINTS: [
    {
      label: '52F4 Status',
      pointName: 'msg_52_f4_52a',
    },
  ],
};
